export const container = `w-full flex flex-row lg:flex-col items-baseline gap-x-4 gap-y-1 text-xs`;
export const title = `text-sm font-medium text-gray-800`;
export const description = `font-normal text-gray-400`;
